import logo from 'assets/images/logo/jseyoung_lion_shield_green.png';

// ==============================|| JEISEYOUNG LOGO IMAGE ||============================== //

export default function LogoMain() {
  return <img src={logo} alt="Jeiseyoung" width="42" height="42" style={{ display: 'block', objectFit: 'contain' }} />;
}
